if (!customElements.get('antinsky-inline-search')) {
  customElements.define('antinsky-inline-search', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const form = this.querySelector('form');
      const input = this.querySelector('input[type="search"]');
      const list = this.querySelector('.antinsky-inline-search__suggestions');
      const button = this.querySelector('button');
      if (!form || !input || !list || !button) return;
      this.initialized = true;
      let timer, request, composing = false;
      const clear = () => {
        clearTimeout(timer);
        request?.abort();
        list.hidden = true;
        list.replaceChildren();
      };
      const suggest = () => {
        clear();
        const value = input.value.trim();
        if (value.length < 2 || this.dataset.predictive !== 'true' || composing) return;
        timer = setTimeout(async () => {
          const pending = new AbortController();
          request = pending;
          const url = new URL(this.dataset.suggest, location.origin);
          url.searchParams.set('q', value);
          url.searchParams.set('resources[type]', 'product');
          url.searchParams.set('resources[limit]', '5');
          if (['hide','show','last'].includes(this.dataset.unavailable)) url.searchParams.set('resources[options][unavailable_products]', this.dataset.unavailable);
          try {
            const response = await fetch(url, { signal: pending.signal });
            if (!response.ok) return;
            const data = await response.json();
            if (pending.signal.aborted || input.value.trim() !== value || !this.contains(document.activeElement)) return;
            for (const item of data.resources?.results?.products || []) {
              const product = new URL(item.url, location.origin);
              if (product.origin !== location.origin) continue;
              const link = document.createElement('a');
              link.href = product.href;
              if (item.image) {
                const src = new URL(item.image, location.origin);
                if (src.protocol === 'https:') {
                  const img = document.createElement('img');
                  img.src = src.href; img.alt = '';
                  link.append(img);
                }
              }
              const title = document.createElement('span');
              title.textContent = item.title;
              link.append(title);
              list.append(link);
            }
            list.hidden = !list.childElementCount;
          } catch {}
        }, 220);
      };
      button.addEventListener('click', event => {
        if (document.activeElement !== input && (!input.value.trim() || this.classList.contains('antinsky-inline-search--mobile') && !this.dataset.editing)) {
          event.preventDefault();
          input.focus();
        }
      });
      form.addEventListener('submit', event => {
        if (!input.value.trim()) { event.preventDefault(); input.focus(); }
        else input.value = input.value.trim();
      });
      input.addEventListener('focus', () => { this.dataset.editing = 'true'; suggest(); });
      input.addEventListener('input', suggest);
      input.addEventListener('compositionstart', () => { composing = true; clear(); });
      input.addEventListener('compositionend', () => { composing = false; suggest(); });
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) { clear(); delete this.dataset.editing; }
      });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !event.isComposing) {
          event.preventDefault();
          event.stopPropagation();
          clear();
          document.activeElement.blur();
        }
        if (event.key === 'ArrowDown' && event.target === input && !list.hidden) {
          event.preventDefault();
          list.querySelector('a')?.focus();
        }
      });
    }
  });
}
